export const UPDATE_SEARCH_STATE = 'UPDATE_SEARCH_STATE';
export const UPDATE_CONFIG = 'UPDATE_CONFIG';
export const UPDATE_PRODUCT_COMPONENTS = 'UPDATE_PRODUCT_COMPONENTS';
export const UPDATE_FILTER = 'UPDATE_FILTER';
export const UPDATE_FILTER_VALUES = 'UPDATE_FILTER_VALUES';
export const FETCHING_PRODUCTS = 'FETCHING_PRODUCTS';
export const UPDATE_SELECTED_PRODUCT = 'UPDATE_SELECTED_PRODUCT';
export const UPDATE_PRODUCT_PARAMS = 'UPDATE_PRODUCT_PARAMS';
export const UPDATE_UNITS_OF_PRICE = 'UPDATE_UNITS_OF_PRICE';
// PRODUCT TYPES
export const SHOW_ERROR_MESSAGE = 'SHOW_ERROR_MESSAGE';
